import { Component, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";

@Component
class UtilityMixin extends Vue {
  public get isMobile() {
    var isMobile = window.screen.width < 576;
    return isMobile;
  }

  public loadingCursor(loading) {
    if (loading) {
      document.body.id = "waiting";
    } else {
      document.body.id = null;
    }
  }

  public scrollToTop(dest, behavior) {
    if (!behavior) behavior = "auto"; // auto or smooth
    if (!dest) dest = "app-top";
    window.setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  formatDate(date) {
    const lang = this.$store.getters.currentLanguage;
    return DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy à T");
  }

  formatDateLong(date) {
    const lang = this.$store.getters.currentLanguage;
    const dateFormatted = DateTime.fromISO(date).setLocale(lang).toFormat("dd MMMM yyyy");
    const timeFormatted = DateTime.fromISO(date).setLocale(lang).toLocaleString(DateTime.TIME_SIMPLE);
    if (dateFormatted.indexOf("Invalid") > -1) return;
    else return dateFormatted + " à " + timeFormatted;
  }

  formatDateSmall(date) {
    const lang = this.$store.getters.currentLanguage;
    const dateFormatted = DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy");
    const timeFormatted = DateTime.fromISO(date).setLocale(lang).toLocaleString(DateTime.TIME_SIMPLE);
    if (dateFormatted.indexOf("Invalid") > -1) return;
    else return dateFormatted + " à " + timeFormatted;
  }

  formatDateMini(date) {
    const lang = this.$store.getters.currentLanguage;
    const dateFormatted = DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy");
    if (dateFormatted.indexOf("Invalid") > -1) return;
    else return dateFormatted;
  }

  formatSnakeToCamelCase(string) {
    return string
      .toLowerCase()
      .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
  }

  public wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public replaceCharAtIndex(str: string, index: number, newText: string) {
    console.log(str.substring(0, index-1));
    return str.substring(0, index-1) + newText + str.substring(index);
  }

  public replaceNthInstanceOfStrWith(str, toReplace, newText, instanceIndex) {
    return str.replace( RegExp("^(?:.*?" + toReplace + "){" + instanceIndex + "}"), (x) => {return x.replace(RegExp(toReplace + "$"), newText)} );
  }

  public getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  public removeDuplicatesFromArray(arr) {
    let ids = arr.map((o) => o.id);
    return arr.filter(({ id }, index) => !ids.includes(id, index + 1));
  }

  public base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  downloadFile(filePath, name) {
    var link = document.createElement("a");
    link.href = filePath;
    link.download = name;
    link.click();
  }

  get checkBrowser() {
    var isChromium: any = (window as any).chrome;
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof (window as any).opr !== "undefined";
    var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    var isIOSChrome = winNav.userAgent.match("CriOS");

    let browser = "";

    if (isIOSChrome) {
      // is Google Chrome on IOS
      browser = "ChromeIOS";
    } else if (
      isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === "Google Inc." &&
      isOpera === false &&
      isIEedge === false
    ) {
      // is Google Chrome
      browser = "Chrome";
    } else {
      browser = "Other";
    }
    return browser;
  }
}
export default UtilityMixin;
